import React, { FC } from 'react';

const NotFoundScreen: FC = () => {
  return <div>Not found...</div>;
} 

export default NotFoundScreen;